<template>
  <div>
    <a-card
      :bordered="false"
      title="订单详情"
    >
      <template v-if="formData.order_type==='PLATFORM'">
        <a-button
          v-if="formData.platform_status==='NORMAL'"
          slot="extra"
          :loading="confirmLoading"
          class="mr-10"
          @click="handleCancelOrder"
        >
          取消订单
        </a-button>
        <a-button
          v-if="formData.platform_status==='NORMAL'"
          slot="extra"
          type="primary"
          class="mr-10"
          @click="handlePay"
        >
          支付
        </a-button>
        <a-button
          v-if="formData.platform_status==='DELIVERED'"
          slot="extra"
          type="primary"
          :loading="confirmLoading"
          @click="handleConfirmReceive"
        >
          确认收货
        </a-button>
      </template>
      <template v-if="formData.order_type==='LOCAL'">
        <a-button
          style="margin-left: 40px"
          slot="extra"
          type="primary"
          :loading="confirmLoading"
          @click="selectPrinter"
        >
          确认打印
        </a-button>
      </template>
      <a-form-model
        ref="form"
        :model="formData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <div class="form-title">基本信息</div>
        <a-form-model-item label="订单号">
          {{ formData.orderId }}
        </a-form-model-item>
        <div style="display: none" id="oId">
          {{ formData.orderId }}
        </div>
        <a-form-model-item label="订单类型">
          {{ formData.order_type | valInDict(dict.orderTypeDict) }}
        </a-form-model-item>
        <template v-if="formData.order_type==='PLATFORM'">
          <a-form-model-item label="状态">
            <a-tag :color="formData.platform_status | statusTagFilter">
              {{ formData.platform_status | valInDict(dict.statusDict) }}
            </a-tag>
          </a-form-model-item>
          <a-form-model-item label="订单金额">
            {{ formData.total_price }} 元
          </a-form-model-item>
          <a-form-model-item label="支付方式">
            {{ formData.pay_type | valInDict(dict.payTypeDict) }}
          </a-form-model-item>
        </template>
        <a-form-model-item label="最后更新时间">
          {{ formData.update_time }}
        </a-form-model-item>
        <a-form-model-item label="创建时间">
          {{ formData.create_time }}
        </a-form-model-item>
        <div class="form-title">订单内容</div>
        <a-form-model-item label="打印模板">
          {{ formData.template_name }}
          <!-- 效果图 props: mouldData -->
          <print-mould
            v-if="templateDetail"
            :mouldData="templateDetail"
          />
        </a-form-model-item>
        <a-form-model-item label="类型">
          {{ formData.relation_type | valInDict(dict.relationTypeDict) }}
        </a-form-model-item>
        <a-form-model-item label="页面/商品名称">
          {{ formData.relation_name }}
        </a-form-model-item>
        <a-form-model-item label="打印序号">
          {{ formData.start_sc_id }} - {{ formData.end_sc_id }}
        </a-form-model-item>
        <a-form-model-item label="打印数量">
          {{ formData.security_code_count }}
        </a-form-model-item>
        <template v-if="formData.order_type==='PLATFORM'">
          <div class="form-title">配送信息</div>
          <a-form-model-item label="收货地址">
            {{ formData.receiver }}，{{ formData.phone }}，{{ formData.address }}
          </a-form-model-item>
          <a-form-model-item label="快递公司">
            {{ formData.express || '--' }}
          </a-form-model-item>
          <a-form-model-item label="快递单号">
            {{ formData.express_number || '--' }}
          </a-form-model-item>
          <a-form-model-item label="物流跟踪">
            <div v-if="formData.express_info" style="margin-top: 15px;">
              <a-timeline>
                <a-timeline-item
                  v-for="(item, index) in formData.express_info.list"
                  :key="index"
                ><span class="mr-10">{{ item.time }}</span> {{ item.status }}</a-timeline-item>
              </a-timeline>
            </div>
            <span v-else>--</span>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-card>
    <!-- 支付面板弹框 -->
    <pay-panel
      ref="payPanel"
      :default-pay-type="formData.pay_type"
      :price="formData.total_price"
      order-type="PRINT"
      @close="getDetail"
    />
    <!-- 打印服务 -->
    <print-service
      ref="PrintService"
      :printData="printData"
    />
    <print-service-new
      ref="PrintServiceNew"
      :printData="printData"
    />
  </div>
</template>
<script>
import PayPanel from '@/components/PayPanel'
import PrintMould from '@/components/PrintMould'
import PrintService from '@/components/PrintService'
import PrintServiceNew from '@/components/PrintServiceNew'
import { deepClone } from '@/utils'
import {
  getOrderPrinterList,
  getOrderPre,
  getOrderDetail,
  postCancalOrder,
  postOrderReceived,
  getTemplateDetail
} from '@/api/print'

export default {
  name: 'OrderDetail',
  components: { PayPanel, PrintMould, PrintService, PrintServiceNew },
  data() {
    return {
      order_id: '',
      orderId: '',
      confirmLoading: false,
      labelCol: { xxl: { span: 2 }, lg: { span: 3 }, md: { span: 5 }, sm: { span: 8 } },
      wrapperCol: { span: 16 },
      formData: {},
      // 字典
      dict: {
        statusDict: []
      },
      templateDetail: null, // 模板详情
      printData: {}
    }
  },
  created() {
    this.order_id = this.$route.query && this.$route.query.id ? this.$route.query.id : ''
    this.getDetail()
    this.getPre()
  },
  methods: {
    // 支付
    handlePay() {
      this.$refs.payPanel.showModal(this.orderId)
    },
    // 取消订单
    handleCancelOrder() {
      this.$confirm({
        title: '确定要取消订单?',
        onOk: () => {
          this.confirmLoading = true
          postCancalOrder({
            order_type: 'PRINT',
            orderId: this.orderId
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('取消订单成功')
                this.getDetail()
              }
            })
            .catch((e) => {
              this.$message.error('取消订单失败')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    // 确认收货
    handleConfirmReceive() {
      this.$confirm({
        title: '是否确认收货?',
        onOk: () => {
          this.confirmLoading = true
          postOrderReceived({
            orderId: this.orderId
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('确认收货成功')
                this.getDetail()
              }
            })
            .catch((e) => {
              this.$message.error('确认收货失败')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    // 预加载
    getPre() {
      getOrderPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.statusDict = data.statusDict
            this.dict.relationTypeDict = data.relationTypeDict
            // 支付方式
            this.dict.payTypeDict = data.payTypeDict
            this.dict.orderTypeDict = data.orderTypeDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载接口失败')
        })
    },
    // 详情
    getDetail() {
      getOrderDetail({
        order_id: this.order_id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = deepClone(data)
            this.orderId = data.orderId
            this.getTemplateDetail(data.template_id)
          }
        })
        .catch((e) => {
          this.$message.error('请求详情接口失败')
        })
    },
    // 模板详情
    getTemplateDetail(template_id) {
      getTemplateDetail({
        template_id: template_id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            // 判断是否有小于12px的字体
            var unit = data.unit
            for (var i = 0; i < unit.length; i++) {
              var _i = unit[i]
              if (_i.type === 'TEXT' && _i.font_size < 2.4) {
                data.unit[i].zoom = this.is360(_i.font_size)
              }
            }
            this.templateDetail = data
          } else {
            this.templateDetail = null
          }
        })
        .catch((e) => {
          this.$message.error('请求模板详情接口失败')
        })
    },
    // 确认打印
    handleConfirmPrint() {
      this.getOrderPrinterList(this.orderId)
    },
    selectPrinter() {
      // 选择打印机
      this.confirmLoading = true
      getOrderPrinterList({
        orderId: this.orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            // 打开打印面板
            this.printData = data
            this.$refs.PrintServiceNew.showModal()
          }
          if (res.code === 10086) {
            this.$message.warning('抱歉，云码尚未全部生成，请稍后', 3)
          }
        })
        .catch((e) => {
          this.$message.error('请求云码列表失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 获取订单 要打印的云码列表
    getOrderPrinterList(orderId) {
      this.confirmLoading = true
      getOrderPrinterList({
        orderId: orderId
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            // 打开打印面板
            this.printData = data
            this.$refs.PrintService.showModal()
          }
          if (res.code === 10086) {
            this.$message.warning('抱歉，云码尚未全部生成，请稍后', 3)
          }
        })
        .catch((e) => {
          this.$message.error('请求云码列表失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 兼容360和谷歌字体不能小于12px的问题
    is360(size) {
      var userAgent = navigator.userAgent
      var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1
      // 判断是否是谷歌
      if (isChrome) {
        return size * 5 / 12
      }
      return 1
    }
  }
}
</script>

<style lang="less" scoped>
.form-title {
  background: transparent;
  padding: 24px 0;
  zoom: 1;
  margin-bottom: -1px;
  min-height: 48px;
  font-size: 16px;
  color: @heading-color;
  font-weight: 500;
}
</style>
